import type { FileProps } from '@elfsight/widget-form-builder/widget';
import {
  fieldComponents as defaultComponents,
  File as FormBuilderFile
} from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';
import { useEmailSubmitPopup } from '../../../use-email-submit-popup';
import { DateComponent } from './date';

const File = (props: FileProps) => {
  const { t } = useLingui();

  const {
    popupStyles: { errorColor }
  } = useEmailSubmitPopup();

  return (
    <FormBuilderFile
      {...props}
      extensionErrorMessage={t`This file cannot be uploaded because the file format is unsupported`}
      emptyFileErrorMessage={t`This file cannot be uploaded because it is empty`}
      fileSizeExceededErrorMessage={t`This file cannot be uploaded because file size limit (100 MB) is exceeded`}
      dropFileText={t`Drop file here`}
      chooseFileText={t`Choose file`}
      orDropFileText={t`or drop file here`}
      errorColor={errorColor}
    />
  );
};

export const fieldComponents = {
  ...defaultComponents,
  date: DateComponent,
  file: File
};
